import React from 'react';
import NumberFormat from 'react-number-format';
import PropTypes from 'prop-types';

// maxValue === 0 means no limitation, default limitation is 99.99
const PercentageFormat = React.forwardRef((props, ref) => {
  const { onChange, name, maxValue, ...other } = props;

  const setRef = React.useCallback(
    (maskedInputRef) => {
      const value = maskedInputRef ? maskedInputRef.inputElement : null;

      if (typeof ref === 'function') {
        ref(value);
      } else if (ref) {
        ref.current = value;
      }
    },
    [ref],
  );

  return (
    <NumberFormat
      {...other}
      getInputRef={setRef}
      onValueChange={(values) => {
        onChange({
          target: {
            name: name,
            value: values.value,
          },
        });
      }}
      isNumericString
      allowNegative={false}
      decimalScale={2}
      suffix=" %"
      isAllowed={(values) => {
        const { floatValue } = values;
        return ((maxValue && maxValue > 0) ? floatValue <= maxValue : (maxValue === 0 ? false : floatValue <= 99.99)) || isNaN(floatValue);
      }}
    />
  );
});

PercentageFormat.propTypes = {
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired
};

export default PercentageFormat;